<div class="sticky-div px-4 py-3 text-bg-secondary shadow-sm">
    <ng-content></ng-content>
</div>
